import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { APP_BASE_HREF } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {
  type ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_LUXON_DATE_ADAPTER_OPTIONS,
  type MatLuxonDateAdapterOptions,
  provideLuxonDateAdapter,
} from '@angular/material-luxon-adapter';
import { provideRouter } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideMarkdown, SANITIZE } from 'ngx-markdown';

import { AppInterceptor } from '@core/interceptors/app-interceptor/app.interceptor';
import { ErrorHandlingInterceptor } from '@core/interceptors/error-handling.interceptor';
import { CsrfTokenService } from '@core/services/csrf-token.service';
import { sanitizeMarkdown } from '@helpers/sanitization';
import { MY_FORMATS } from '@shared/constants/ume-constants';

import { appRoutes } from './app-routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const csrfService: CsrfTokenService = inject(CsrfTokenService);
      return csrfService.refreshToken();
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes
      // withDebugTracing()
    ),
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlingInterceptor,
      multi: true,
    },
    provideLuxonDateAdapter(),
    {
      provide: MAT_LUXON_DATE_ADAPTER_OPTIONS,
      useValue: {
        useUtc: true,
      } satisfies Partial<MatLuxonDateAdapterOptions>,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withInterceptorsFromDi(), withXhr()),
    provideMarkdown({
      sanitize: {
        provide: SANITIZE,
        useValue: sanitizeMarkdown,
      },
    }),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
  ],
};
